var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg012Print(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.31,14.47h-2.36v-3.64s-.01-.04-.01-.06c0-.09-.02-.17-.05-.26-.01-.03-.02-.06-.03-.09-.05-.11-.11-.21-.2-.29l-6.81-6.82c-.09-.09-.19-.15-.29-.2-.03-.01-.06-.02-.09-.03-.09-.03-.17-.05-.26-.05-.02,0-.04-.01-.06-.01H11.47c-1.34,0-2.43,1.09-2.43,2.43v9.03h-2.36c-2.22,0-4.03,1.81-4.03,4.03v13.5c0,2.23,1.81,4.05,4.03,4.05h2.36v6.69c0,1.24,1,2.25,2.24,2.25h25.44c1.23,0,2.24-1.01,2.24-2.25v-6.69h2.36c2.22,0,4.03-1.82,4.03-4.05v-13.5c0-2.22-1.81-4.03-4.03-4.03ZM32.15,6.43l3.39,3.4h-2.97c-.24,0-.43-.19-.43-.43v-2.97ZM11.04,5.44c0-.24.19-.43.43-.43h18.68v4.39c0,1.34,1.09,2.43,2.43,2.43h4.38v2.64H11.04V5.44ZM36.96,42.74c0,.14-.11.25-.24.25H11.28c-.13,0-.24-.11-.24-.25v-14.73h25.91v14.73ZM43.35,32c0,1.13-.91,2.05-2.03,2.05h-2.36v-6.05h.86c.55,0,1-.45,1-1s-.45-1-1-1h-1.86s0,0-.01,0H10.06s0,0-.01,0h-1.86c-.55,0-1,.45-1,1s.45,1,1,1h.86v6.05h-2.36c-1.12,0-2.03-.92-2.03-2.05v-13.5c0-1.12.91-2.03,2.03-2.03h34.63c1.12,0,2.03.91,2.03,2.03v13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.29,20.45h-2.25c-.55,0-1,.45-1,1s.45,1,1,1h2.25c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.61,30.46H14.18c-.55,0-1,.45-1,1s.45,1,1,1h19.43c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.61,34.05H14.18c-.55,0-1,.45-1,1s.45,1,1,1h19.43c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.61,37.64H14.18c-.55,0-1,.45-1,1s.45,1,1,1h19.43c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg012Print);
export default __webpack_public_path__ + "static/media/012-print.405cd5c8b91004aac3d3e28bc4f4bc90.svg";
export { ForwardRef as ReactComponent };